var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"das_top_cont flex_center",staticStyle:{"height":"35.714285714285715rem","font-size":"2.142857142857143rem"}},[_vm._v(" This page is currently under development ")])])
}]

export { render, staticRenderFns }